import { render, staticRenderFns } from "./RelationshipType.vue?vue&type=template&id=3a3055c3"
import script from "./RelationshipType.vue?vue&type=script&lang=js"
export * from "./RelationshipType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3055c3')) {
      api.createRecord('3a3055c3', component.options)
    } else {
      api.reload('3a3055c3', component.options)
    }
    module.hot.accept("./RelationshipType.vue?vue&type=template&id=3a3055c3", function () {
      api.rerender('3a3055c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/RelationshipType.vue"
export default component.exports